<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('printer_edit')">
      <v-btn
          v-if="item"
          :color="colorOutOfOrder"
          @click="outOfOrder"
      >{{textButtonOutOfOrder}}</v-btn>

      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <v-badge
              :color="colorState"
              overlap
              right
              inline
          >
            <h1><v-icon large>mdi-printer-3d</v-icon>{{ item['name'] }}</h1>
          </v-badge>

        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-printer-show">
      <v-row>
        <v-col md="4">
          <ImageView  :item="item" height="400" width="400" filter="400x400" :edit="userHasAccess('prodfile_edit')"  />
        </v-col>
        <v-col md="8">
          <v-simple-table>
            <template slot="default">
              <thead>
              <tr>
                <th>{{ $t('global.field') }}</th>
                <th>{{ $t('global.value') }}</th>

                <th>{{ $t('global.field') }}</th>
                <th>{{ $t('global.value') }}</th>
              </tr>
              </thead>

              <tbody>
              <tr>
                <td><strong>{{ $t('global.name') }}</strong></td>
                <td>
                  {{ item['name'] }}
                </td>
                <td><strong>{{ $t('printer.interfacemachine') }}</strong></td>
                <td>
                  <v-btn
                      color="secondary"
                      class=""
                      @click="linkMachine()"
                  >
                    {{ $t('global.view') }}
                    <v-icon
                        right
                        dark
                    >mdi-location-enter
                    </v-icon>
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td><strong>{{ $t('printer.machine') }}</strong></td>
                <td>
                  <span v-if="item['machine']">{{ item['machine'].name }}</span>
                </td>
                <td><strong>{{ $t('printer.address') }}</strong></td>
                <td>
                  {{ item['address'] }}
                </td>

              </tr>
              <tr>
                <td><strong>{{ $t('printer.api') }}</strong></td>
                <td>
                  <span v-if="item.api" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                  <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
                </td>
                <td><strong>{{ $t('printer.enabled') }}</strong></td>
                <td>
                  <span v-if="item.enabled" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                  <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
                </td>

              </tr>
              <tr>
                <td><strong>{{ $t('global.updated') }}</strong></td>
                <td>
                  <span v-if="item.updated" class="mr-2">{{ formatDateTime(item['updated'], 'long') }}</span>
                </td>
                <td><strong>{{ $t('printer.tags') }}</strong></td>
                <td>
                  <div id="tags">
                    <v-chip v-for="tag in item['tags']" :key="tag.id"
                            class="ma-1 font-weight-bold"

                            color="accent"
                    >
                      {{ tag.name }}
                    </v-chip>
                  </div>
                </td>

              </tr>

              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import { colorPrinter } from '../../utils/color';
import ImageView from '../../components/ImageView';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Printer';

export default {
  name: 'PrinterShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar,
    ImageView
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    textButtonOutOfOrder() {
      if (this.item.outOfOrder) {
        return this.$t('printer.markOk')
      } else return this.$t('printer.markOut')
    },
    ...mapFields('printer', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('printer', ['find']),
    colorState() {
      return colorPrinter(this.item);
    },
    colorOutOfOrder() {
      if (!this.item.outOfOrder) {
        return 'primary'
      } else {
        return 'red'
      }
    }
  },
  methods: {
    ...mapActions('printer', {
      update: 'update',
    }),
      outOfOrder() {
      if (this.item.outOfOrder) {
        this.update({"@id": this.item['@id'], "outOfOrder": false})
      } else {
        this.update({"@id": this.item['@id'], "outOfOrder": true})
      }
    },
    ...mapActions('printer', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    linkMachine: function () {
      window.open("http://"+ this.item.address, "_blank");
    },
    colorPrinter
  },
};
</script>
